module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/icon_time-c3d1f9ea52aeb78816486d95fdff3a7f.png";